import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

const getCountButton = (listView, theme, detailsMode) => {
  if (listView) {
    return {
      width: 130,
      height: 36,
      [theme.breakpoints.down('lg')]: {
        width: pickIf(detailsMode, 200, 96),
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.down('md')]: {
        width: pickIf(detailsMode, 140, 96),
        height: pickIf(detailsMode, 44, 24),
      },
    };
  }
  return {
    width: '50%',
    maxWidth: pickIf(detailsMode, 130, 128),
    height: 36,
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 'initial'),
      height: pickIf(detailsMode, 44, 34),
      marginLeft: !detailsMode && 'auto',
      marginRight: !detailsMode && 'auto',
    },
    [theme.breakpoints.down('md')]: {
      minWidth: pickIf(detailsMode, 140, 124),
      height: pickIf(detailsMode, 44, 24),
    },
  };
};

const getAddToKitButton = (listView, theme, detailsMode) => {
  if (listView) {
    return {
      width: 130,
      height: 36,
      padding: theme.spacing(1),
      [theme.breakpoints.down('lg')]: {
        width: pickIf(detailsMode, 200, 105),
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.down('md')]: {
        width: pickIf(detailsMode, 140, '100%'),
        height: pickIf(detailsMode, 44, 32),
      },
    };
  }
  return {
    width: pickIf(detailsMode, 130, '50%'),
    maxWidth: pickIf(detailsMode, 'unset', 130),
    height: 36,
    padding: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      minWidth: pickIf(detailsMode, 200, 96),
      height: pickIf(detailsMode, 44, 34),
    },
    [theme.breakpoints.down('md')]: {
      width: pickIf(detailsMode, 140, 124),
      minWidth: pickIf(detailsMode, 140, 'unset'),
      maxWidth: pickIf(detailsMode, 'unset', 124),
      height: pickIf(detailsMode, 44, 32),
    },
  };
};

export const useStyles = makeStyles()(
  (theme, { detailsMode, listView } = {}) => ({
    container: {
      position: 'relative',
      display: 'flex',
      flexDirection: pickIf(detailsMode || !listView, 'row', 'column'),
      alignItems: 'center',
      gap: 10,
      padding: 0,
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        flexDirection: 'row',
      },
      [theme.breakpoints.down('md')]: {
        marginRight: 0,
        justifyContent: pickIf(!detailsMode && !listView, 'center', 'unset'),
        width: '100%',
      },
    },
    countButton: getCountButton(listView, theme, detailsMode),
    addToKitButton: getAddToKitButton(listView, theme, detailsMode),
  }),
);
